var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"id":_vm.id,"title":"选择目录","size":"tiny"},on:{"ok":_vm.ok}},[_c('DirectoryTree',{ref:"dirTree",attrs:{"root":_vm.root,"default":_vm.root},on:{"change":function($event){_vm.value = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }